var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c("TopBar", { staticStyle: { "grid-area": "topbar", "z-index": "2" } }),
      _c("Pin", { staticStyle: { "grid-area": "pin" } }),
      _c("Controls", {
        staticStyle: { "grid-area": "controls", "z-index": "1" },
      }),
      _c("BottomBar", { staticStyle: { "z-index": "2" } }),
      _vm.categoryMenuOpen ? _c("CategoryMenu") : _vm._e(),
      _c("div", { staticClass: "home__background" }, [_c("Background")], 1),
      _c("UploadModal", {
        attrs: { opened: _vm.uploading },
        on: {
          close: function ($event) {
            return _vm.finishEditingUpload(false)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }